import React from "react";
import EditableText from "./EditableText";
import { useEditMode } from "../lib/EditModeContext";

/**
 * EditableLabel — for static UI text (section titles, column headers, captions).
 * Persists overrides to the ui_labels store, keyed by `labelKey`.
 * If no override exists, renders `defaultText`.
 */
const EditableLabel = ({
  labelKey,
  defaultText,
  as = "span",
  className = "",
  inputClassName = "",
  multiline = false,
  testid,
}) => {
  const { getLabel, saveLabel } = useEditMode();
  const current = getLabel(labelKey, defaultText);
  return (
    <EditableText
      value={current}
      onSave={(next) => saveLabel(labelKey, next)}
      as={as}
      className={className}
      inputClassName={inputClassName}
      multiline={multiline}
      testid={testid || `label-${labelKey}`}
      emptyPlaceholder={defaultText}
    />
  );
};

export default EditableLabel;
